import styled from 'styled-components';

export const Content = styled.div`
  .holiday-wrapper {
    padding: 0 0 30px;
    .image {
      width: 100%;
    }
    .description {
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: var(--color-fixed-brand);
    }
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
      color: var(--color-text-muted);
      padding: 0 10px 0 0;
    }

    .input,
    .textarea {
      margin: 0 0 20px;
    }
  }

  .card {
    color: var(--color-text);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    padding: 0 0 20px;

    &.red {
      color: red;
    }
  }

  .rates {
    display: flex;
    gap: 5px;

    .rate {
      border-radius: 14px;
      padding: 2px;

      &.active {
        background: linear-gradient(to right, #7aabf3, #2765be);
      }

      &.current .current {
        display: flex;
      }

      .current {
        display: none;
        width: 130px;
        padding: 2px 4px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px 10px 0 0;
        color: var(--color-surface);
        background: var(--color-title);
        top: 0;
        left: 0;
        position: absolute;
        text-transform: uppercase;

        text-align: center;
        font-size: 9px;
        font-style: normal;
        font-weight: 600;
        line-height: 160%;
      }

      .rate-white {
        border-radius: 12px;
        background: var(--color-surface);
        padding: 3px;
      }

      .rate-inner {
        border-radius: 10px;
        background: var(--color-surface-muted);
        display: flex;
        flex-direction: column;
        width: 130px;
        height: 110px;
        padding: 0 10px;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
      }

      .freelancer {
        background: #edf3ff;
      }

      .pro {
        background: #dfe8f8;
      }

      .agency {
        background: #d2ddf5;
      }

      .business {
        background: #c5d2ee;
      }

      .rate-name {
        color: var(--color-fixed-brand);
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        text-transform: uppercase;
      }

      .rate-requirements,
      .rate-price {
        color: var(--color-fixed-brand);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;

        &.striked {
          text-decoration: line-through;
        }

        &.promo {
          color: #ff2f2f;
          font-weight: 700;
        }
      }
    }
  }

  .range-wrapper {
    position: relative;

    .only-x-left {
      position: absolute;
      z-index: 200;
      left: 0;
      top: -30px;
      color: var(--color-text);
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 130%;
      padding: 5px;
      border-radius: 5px;
      width: 162px;
      transform: translateX(-73px);
      background-color: var(--color-surface);
      border: 1px solid var(--color-border);
      box-shadow: 0 8px 10px rgba(0, 0, 0, 0.15);

      &::after {
        content: ' ';
        position: absolute;
        margin-left: -8px;
        border-width: 8px;
        border-style: solid;
        border-color: var(--color-surface) transparent transparent;
        top: 41px;
        left: 50%;
        z-index: 10000;
      }
    }
  }

  .range {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    height: 4px;
    margin: 30px 0 10px;
    width: 100%;
    outline: none;

    &:disabled {
      filter: grayscale(1);
      opacity: 0.3;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
    }

    &::-ms-track {
      width: 100%;
      height: 4px;
      cursor: pointer;
      transition: all ease 200ms;
      background: var(--color-border);
      border-radius: 2px;
    }

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 4px;
      cursor: pointer;
      transition: all ease 200ms;
      background: var(--color-border);
      border-radius: 2px;
    }

    &::-moz-range-track {
      width: 100%;
      height: 4px;
      cursor: pointer;
      transition: all ease 200ms;
      background: var(--color-border);
      border-radius: 2px;
    }

    &::-ms-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 12px;
      height: 12px;
      flex-shrink: 0;
      cursor: pointer;
      box-shadow: 0 0 2px #eee;
      border: 3px solid var(--color-surface);
      border-radius: 12px;
      background: #2765be;
      background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      cursor: pointer;
      box-shadow: 0 0 2px #eee;
      border: 3px solid var(--color-surface);
      border-radius: 12px;
      background: #2765be;
      background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
    }

    &::-moz-range-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 12px;
      height: 12px;
      flex-shrink: 0;
      cursor: pointer;
      box-shadow: 0 0 2px #eee;
      border: 3px solid var(--color-surface);
      border-radius: 12px;
      background: #2765be;
      background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
    }

    &::-webkit-slider-thumb {
      margin-top: -7px;
    }

    &::-ms-thumb {
      margin-top: 1px;
    }

    &::-moz-range-progress {
      border-radius: 2px;
      background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
    }

    &::-webkit-progress-value {
      border-radius: 2px;
      background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
    }

    &::-ms-fill-lower {
      background: var(--color-border);
      border: 0 solid #010101;
      border-radius: 6px;
      box-shadow: 0 0 0 #000000;
    }

    &::-ms-fill-upper {
      background: var(--color-border);
      border: 0 solid #010101;
      border-radius: 6px;
      box-shadow: 0 0 0 #000000;
    }

    &:focus::-ms-fill-lower {
      background: var(--color-border);
    }

    &:focus::-ms-fill-upper {
      background: var(--color-border);
    }
  }

  .amount-line {
    display: flex;
    margin: 20px 0 0;
    gap: 13px;

    .balance {
      color: var(--color-text);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 38px;
      padding: 2px 0 0;

      .striked {
        text-decoration: line-through;
      }

      .promo {
        color: #ff2f2f;
        font-weight: 700;
      }
    }

    .input-wrapper {
      width: 136px;
      &:first-child {
        width: 300px;
        max-width: 100%;
      }

      .label {
        white-space: nowrap;
      }

      input {
        height: 40px;
      }
    }

    .new-rate {
      .label {
        font-weight: 700;
      }
    }
  }

  .description {
    color: var(--color-text-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    padding: 0 0 10px;

    &.red {
      color: #ff2f2f;
      font-weight: 500;
    }

    &.special {
      color: var(--color-fixed-brand);
      font-weight: 500;
    }

    p {
      padding: 0 0 2px 8px;
      margin: 0;

      &:first-child {
        padding-left: 0;
      }
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }

  html[data-theme='dark'] & .rates .rate .freelancer {
    background: #24344f;
  }

  html[data-theme='dark'] & .rates .rate .pro {
    background: #22324b;
  }

  html[data-theme='dark'] & .rates .rate .agency {
    background: #203047;
  }

  html[data-theme='dark'] & .rates .rate .business {
    background: #1f2d43;
  }
`;
